import React from 'react'
import { Button } from 'react-bootstrap'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import { RiDeleteBinLine as DeleteIcon } from 'react-icons/ri'
import {
  IoMdInformationCircleOutline,
  IoIosInformationCircle as InformationIcon,
} from 'react-icons/io'
import { FiEdit3 as EditIcon } from 'react-icons/fi'
import PriceSubscription from 'src/views/components/Price/PriceSubscription'
import {
  getMonthStringList,
  trackGTMEvents,
  getImageFromProperty,
  i18nTranslate,
  currencyFormat,
  checkEnableButton,
} from 'src/utils'
import { subscriptionContainer } from 'src/models'
import {
  LinkWithLocale,
  ImageComponent,
  DatePickerV2,
  FrequencyDropdownV2,
  Quantity,
} from 'src/views/components'
import CartScanCard from '../../CartBlock/CartScanCard/CartScanCard'
import CartScanInfo from '../../SubscriptionComponents/CartScanCardWithInfo/CartScanInfo'
import { pageNames } from 'src/routes/pathParams'
import { imagePlaceholder } from 'src/static/fixtures/imagePlaceholder'
import DeleteItemModal from './DeleteItemModal'
import SkipItemModal from './SkipItemModal'
import { getFrequenciesBasedOnAdminConfig } from 'src/deps/NuskinSubscriptionDeps'
import BundleIncludedItemsCollapse from './BundleIncludedItemsCollapse'
import {
  getLastDateOfCurrentMonth,
  constructDateV2,
  getScanQualifiedCountSumForBundleSubItems,
  currentMonthV2,
  currentYearV2,
  isPbomProduct,
  enableSubscriptionMultiVariant,
} from 'src/deps'
import { SKIP_DELETE_MODAL_TYPES } from 'src/static/fixtures/flexibleSubscription'
import PVCV from '../PVCV'
import EditBundleMultiVariants from '../EditBundleMultiVariants'
import './styles.scss'
@observer
class NextOrderProductDetails extends React.Component {
  @observable showSubscriptionModal = false
  @observable confirmDeleteModel = false
  @observable confirmSkipModel = false
  @observable quantity = 0
  @observable selectedSubscriptionFullDate = new Date()
  @observable selectedSubscriptionDate = new Date().getDate()
  @observable isOneTime = false
  @observable showIncludedBundleItems = false
  @observable frequencyData = {
    frequencyPeriod: 1,
    frequencyType: 'Every month',
    type: 'VARIABLE_MULTI_ORDER',
  }
  @observable scanCardShow = false
  @observable scanCardProductDetails = {}
  @observable bundleScan = false
  @observable bundleScanCount = 0
  @observable isInfoModalEnabled = false

  constructor(props) {
    super(props)
    const { data = {} } = this.props
    const {
      frequencyPeriod = 1,
      frequencyType = 'Every month',
      type = 'VARIABLE_MULTI_ORDER',
    } = data
    this.frequencyData = {
      frequencyPeriod: frequencyPeriod,
      frequencyType: frequencyType,
      type: type,
    }
    this.isOneTime = data.type === 'VARIABLE_SINGLE_ORDER' || false
  }

  componentDidMount() {
    const { data = {}, selectedMonth = 1, availableMinDate = '' } = this.props
    let currentMonth = currentMonthV2() || 0
    const currentYear = currentYearV2()
    const isNextYearMonth = currentMonth > selectedMonth - 1
    const year = isNextYearMonth ? parseInt(currentYear) + 1 : currentYear
    const { recurrenceOrderProcessingDate = '' } = data
    this.selectedSubscriptionFullDate =
      year && selectedMonth && recurrenceOrderProcessingDate
        ? constructDateV2(
            year,
            selectedMonth - 1,
            recurrenceOrderProcessingDate
          )
        : availableMinDate
    this.selectedSubscriptionDate =
      this.selectedSubscriptionFullDate?.getDate() || ''
  }

  /**
   * Generates a product link URL based on the provided link options.
   *
   * Constructs the URL using the product slug or ID, variant,
   * and other provided link options.
   */
  getItemLink = linkOptions => {
    const { data = {} } = this.props || {}
    const { isBundle = false, bundle = {} } = linkOptions || {}
    const productSlug = data?.itemInfo?.[0]?.properties?.slug || ''
    let skuVariant = data?.properties?.slug || ''
    const variantLabel =
      data?.properties?.variantLabel ||
      data?.itemInfo?.[0]?.skus?.[0]?.skuProperties?.variantLabel
    if (!skuVariant) {
      skuVariant = data?.itemInfo?.[0]?.skus?.[0]?.skuProperties?.slug || ''
    }

    const productID = isBundle
      ? bundle?.productId
      : this.props?.data?.itemInfo?.[0]?.skus?.[0]?.productId

    const productOrSlugId = productSlug ? productSlug : productID
    const categoryId = data?.properties?.categoryId || ''
    let productQueryParams = new URLSearchParams()

    if (variantLabel) {
      const slugVariant =
        data?.itemInfo?.[0]?.skus?.[0]?.skuProperties?.slug ||
        data?.itemInfo?.[0]?.skus?.[0]?.id
      productQueryParams.append('variant', slugVariant)
    }
    productQueryParams = productQueryParams.toString()
    const url =
      `${pageNames.product}/${productOrSlugId}` +
      (productQueryParams ? `?${productQueryParams}` : '')
    return url
  }

  /**
   * Handles opening the manage order tab in the subscription container.
   */
  handleManageOrder = () => {
    this.props?.handleTabChange('nextOrder')
  }

  /**
   * Toggles showing the subscription modal by setting
   * showSubscriptionModal to the opposite of its current value.
   */
  togglesSubscriptionModal = () => {
    this.showSubscriptionModal = !this.showSubscriptionModal
  }
  toggleIncludedBundleItems = () => {
    this.showIncludedBundleItems = !this.showIncludedBundleItems
  }
  handleQuantityChange = count => {
    this.quantity = count
    this.triggerProductEdit(false, 'quantityChange')
  }
  checkIfCanSkipOrDelete = (modalType = '') => {
    if (this.props.canSkipOrDelete) {
      return true
    } else {
      this.props.toggleScanInfoModal(modalType)
      return false
    }
  }
  checkIfCanChangeFrequencyToOneTime = () => {
    if (this.props.canChangeFrequencyToOneTime) {
      return true
    } else {
      this.props.toggleScanInfoModal(SKIP_DELETE_MODAL_TYPES.FREQUENCY_CHANGE)
      return false
    }
  }
  handleDeleteItem = () => {
    if (this.checkIfCanSkipOrDelete(SKIP_DELETE_MODAL_TYPES.DELETE)) {
      this.confirmDeleteModel = true
    }
  }
  handleSkipItem = isSkipped => {
    if (
      isSkipped ||
      this.checkIfCanSkipOrDelete(SKIP_DELETE_MODAL_TYPES.SKIP)
    ) {
      this.confirmSkipModel = true
    }
  }

  handleDeleteClose = () => {
    this.confirmDeleteModel = false
  }
  handleSkipClose = () => {
    this.confirmSkipModel = false
  }
  handleCancelItem = subscriptionId => {
    this.confirmDeleteModel = false
    this.props.handleCancelItem(subscriptionId)
  }
  handlerSkipItem = (
    subscriptionId,
    isSkipped,
    itemDetails = {},
    selectedMonth
  ) => {
    this.confirmSkipModel = false
    const data = {
      id: subscriptionId,
      isSkippedSubscription: isSkipped,
    }
    this.trackGTMEventsForSkipOrUnskip(itemDetails, isSkipped)
    this.props.handleSkipItem(data, selectedMonth)
  }
  trackGTMEventsForSkipOrUnskip = (itemDetails, isSkipped) => {
    const {
      productName = '',
      subTotal = 0,
      subscriptionId = '',
    } = itemDetails || {}
    const isItemAlreadySkipped = !isSkipped //As the existing param passed with negation, we referring the same
    isItemAlreadySkipped
      ? trackGTMEvents({
          event: 'subscriptionUndoSkip',
          name: productName,
          id: subscriptionId,
          price: subTotal,
          type: 'next orders',
          message: '',
        })
      : trackGTMEvents({
          event: 'subscriptionskip',
          name: productName,
          id: subscriptionId,
          price: subTotal,
          type: 'next orders',
          message: subscriptionContainer.skipDeleteLoyaltyMFEMsg,
        })
  }

  handleChangeCalendar = async timeStamp => {
    if (!this.checkIfCanSkipOrDelete(SKIP_DELETE_MODAL_TYPES.DATE_CHANGE))
      return
    const data = subscriptionContainer?.flexibleSubscriptionResponse?.[0] || []
    let recurrenceOrderProcessingDate = new Date(timeStamp)
    this.selectedSubscriptionFullDate = recurrenceOrderProcessingDate || ''
    const orderProcessedDate = recurrenceOrderProcessingDate?.getDate() || ''
    this.selectedSubscriptionDate = orderProcessedDate || ''
    const month = recurrenceOrderProcessingDate?.getMonth() || 0
    const monthText = getMonthStringList()[month]
    const renderMonth = data?.selectedMonth || ''
    const renderDate =
      data?.subscriptions?.[0]?.recurrenceOrderProcessingDate || ''
    const currentMonth = new Date().getMonth()
    const selDate = new Date(timeStamp)
    selDate.setMonth(selDate.getMonth() - 1)
    let previousDateAvailable = false
    if (
      data?.subscriptions?.length === 1 &&
      selDate?.getDate() === renderDate &&
      selDate?.getMonth() + 1 === renderMonth
    ) {
      previousDateAvailable = false
    } else if (currentMonth < month) {
      const { availableOrderDates } = this.props
      previousDateAvailable = availableOrderDates?.some(
        processedDate =>
          processedDate?.getDate() === selDate?.getDate() &&
          processedDate?.getMonth() === selDate?.getMonth() &&
          processedDate?.getFullYear() === selDate?.getFullYear()
      )
    }
    if (previousDateAvailable) {
      this.triggerProductEdit(true, 'dateChange', previousDateAvailable)
    } else {
      await this.triggerProductEdit(true, 'dateChange')
      const tabName = `${monthText} ${orderProcessedDate}`
      subscriptionContainer.subscriptionSelectedDate = tabName
    }
  }

  triggerProductEdit = (
    isReloadRequired = false,
    isFrom = '',
    previousDateAvailable = false
  ) => {
    const { handleProductEdit, data } = this.props
    const month = this.selectedSubscriptionFullDate?.getMonth() + 1 || 1
    handleProductEdit(
      data,
      this.frequencyData,
      this.quantity,
      this.isOneTime,
      this.selectedSubscriptionDate,
      false,
      isReloadRequired,
      isFrom,
      month,
      previousDateAvailable
    )
  }
  handleSubscriptionFrequency = (value, isOneTime, event) => {
    if (
      isOneTime &&
      !this.checkIfCanChangeFrequencyToOneTime(
        SKIP_DELETE_MODAL_TYPES.FREQUENCY_CHANGE
      )
    ) {
      event.preventDefault()
      return false
    }

    const [frequencyPeriod, frequencyType] = value?.split?.('-')
    this.frequencyData = {
      frequencyPeriod,
      frequencyType,
      type: isOneTime ? 'VARIABLE_SINGLE_ORDER' : 'VARIABLE_MULTI_ORDER',
    }
    this.isOneTime = isOneTime
    this.triggerProductEdit(false, 'frequencyChange')
    return true
  }

  handleScan = (productInfo = {}, bundle = false, bundleScanCount = 0) => {
    this.scanCardShow = true
    this.bundleScan = bundle
    if (bundle) {
      this.scanCardProductDetails = productInfo?.bundle?.[0] || []
    } else {
      this.scanCardProductDetails = productInfo
    }
    this.bundleScanCount = bundleScanCount
  }

  renderScanCardBtn = (
    productInfo,
    bundle = false,
    disabled = false,
    frequencyOrderType,
    disableTabIndex = 0
  ) => {
    let scanCount = 0

    if (bundle) {
      const skus = this.props?.data?.itemInfo?.[0]?.skus || []
      scanCount = getScanQualifiedCountSumForBundleSubItems(skus)
    } else {
      scanCount = productInfo?.scanQualifiedCount || 0
    }
    return (
      scanCount > 0 &&
      frequencyOrderType === 'VARIABLE_MULTI_ORDER' && (
        <div className="d-flex mt-3" data-testid="qa-ScanCard">
          <Button
            className="scan-card-btn"
            tabIndex={disableTabIndex}
            disabled={disabled}
            onClick={() => {
              this.handleScan(productInfo, bundle, scanCount)
            }}>
            {i18nTranslate('cart.scanCard', 'Scan Card')}
          </Button>
          <button
            className="scan-card-info-icon ml-2"
            tabIndex={disableTabIndex}
            onClick={this.toggleInfoModal}>
            <IoMdInformationCircleOutline size={15} />
          </button>
        </div>
      )
    )
  }

  toggleScanCardShow = () => {
    this.scanCardShow = !this.scanCardShow
  }

  toggleInfoModal = () => {
    this.isInfoModalEnabled = !this.isInfoModalEnabled
  }

  renderDatePicker = props => {
    const { isOneTime, disableTabIndex } = props
    const {
      nonProcessedPastSubscriptionDates = [],
      nonProcessedFutureSubscriptionDates = [],
      availableMinDate = '',
      minDate = '',
      maxDate = '',
      alreadyProcessedOrderDates = [],
      availableOrderDates = [],
      isToDisableCurrentMonthDatesInNextMonth = false,
      isToShowTwoMonthProcessingDates = false,
    } = this.props

    const isToEnableNextMonth = isToShowTwoMonthProcessingDates
    const currentMonthLastDate = getLastDateOfCurrentMonth(minDate)
    const availableMaxDate = isToEnableNextMonth
      ? maxDate
      : currentMonthLastDate

    return (
      <DatePickerV2
        minDate={minDate}
        maxDate={availableMaxDate}
        highlightDates={nonProcessedFutureSubscriptionDates}
        includeDateOnly={
          isOneTime && nonProcessedFutureSubscriptionDates.length
            ? nonProcessedFutureSubscriptionDates
            : []
        }
        selectedDateCalendar={this.selectedSubscriptionFullDate}
        subscriptionProcessedDates={alreadyProcessedOrderDates}
        nonProcessedPastSubscriptionDates={nonProcessedPastSubscriptionDates}
        availableOrderDates={availableOrderDates}
        UTCclock={false}
        isOneTime={isOneTime}
        disableTabIndex={disableTabIndex}
        disableCurrentMonthUnprocessedDatesInNextMonth={
          isToDisableCurrentMonthDatesInNextMonth
        }
        handleChangeCalendar={this.handleChangeCalendar}
        disableShowNextMonth={isToShowTwoMonthProcessingDates}
      />
    )
  }

  render() {
    const { data, isSkipmentSkips = false } = this.props

    const bundleItems = subscriptionContainer.getBundleData(data)
    const isBundle = bundleItems?.isBundle || false
    const productImage = getImageFromProperty(
      isBundle
        ? bundleItems?.bundle?.[0]?.skuProperties
        : data?.itemInfo?.[0]?.skus?.[0]?.skuProperties
    )
    const _bundle = {
      ...bundleItems,
      ...(bundleItems?.skuProperties || {}),
      ...(bundleItems?.bundle?.[0]?.skuProperties || {}),
    }
    let productInfo = isBundle
      ? _bundle
      : this.props?.data?.itemInfo?.[0]?.skus?.[0]?.skuProperties
    const skuDetails = isBundle
      ? bundleItems?.bundle?.[0]?.skuProperties
      : data?.itemInfo?.[0]?.skus?.[0]?.skuProperties
    const url = this.getItemLink({ isBundle, bundleItems })
    const skuId = isBundle
      ? bundleItems.bundle?.[0].productId
      : data?.itemInfo?.[0]?.skus?.[0]?.id || ''
    const currencySign =
      subscriptionContainer.subscriptionPreferenceResponse?.currencySign || '$'
    const totalValue = data?.itemInfo?.[0]?.totalValue || {}
    const unitValue = data?.itemInfo?.[0]?.unitValue || {}
    const { originalPrice = '', priceAfterDiscount = '' } = unitValue

    const isStarterKit =
      data?.itemInfo?.[0]?.properties?.isstarterkit || '' === 'true'
        ? true
        : false
    const partNumber = data?.itemInfo?.[0]?.properties?.partnumber || ''
    const priceObj = {
      currencySymbol: currencySign,
      price: parseFloat(originalPrice),
      discountedPrice: parseFloat(priceAfterDiscount),
      totalValue: {
        originalPrice: parseFloat(originalPrice),
        priceAfterDiscount: parseFloat(priceAfterDiscount),
      },
      unitValue: unitValue,
    }

    const isSkipped = data?.properties?.isSkipped === 'true' || false
    const skipText = isSkipped
      ? i18nTranslate('subscription.undoSkipText', 'Undo Skip')
      : i18nTranslate('subscription.skipText', 'Skip')
    let frequenciesBasedOnAdminConfig = getFrequenciesBasedOnAdminConfig({
      isMonthlyLabel: true,
    })
    let {
      frequencyPeriod = 1,
      frequencyType = 'Every month',
      type = 'VARIABLE_MULTI_ORDER',
    } = data
    const availableChannels = skuDetails?.availableChannels || ''
    const isSubscriptionChannelAvailable =
      checkEnableButton(availableChannels, 'subscription') || false
    let frequencyLabel = frequenciesBasedOnAdminConfig[0].label
    let isOneTime = false
    const frequencyValue = `${frequencyPeriod}-${frequencyType}`
    const subscriptionVal = frequenciesBasedOnAdminConfig.filter(
      item => frequencyValue == item.value
    )
    if (subscriptionVal.length) {
      if (subscriptionVal.length === 1) {
        frequencyLabel = subscriptionVal[0].label
      } else {
        if (type === 'VARIABLE_SINGLE_ORDER') {
          frequencyLabel = subscriptionVal[1].label
          isOneTime = subscriptionVal?.[1]?.isOneTime || false
        } else {
          frequencyLabel = subscriptionVal[0].label
        }
      }
    }

    const isBundleOnly =
      bundleItems?.bundle?.[0]?.type?.toLowerCase() === 'bundle'
    let variantInfo = {}
    if (!isBundle) {
      const { variantLabel = '', variantColor = '' } = productInfo

      if (variantLabel) {
        variantInfo.isNormalSkuWithMultiVariant = true
        variantInfo.variantLabel = variantLabel
      }
    }

    const details = {
      productImage,
      pathUrl: url,
      productName: productInfo.name || '',
      skuId,
      partNumber,
      isStarterKit,
      priceObj,
      frequencyLabel,
      quantity: this.quantity || data?.itemInfo?.[0]?.quantity,
      subTotal: totalValue?.priceAfterDiscount || '',
      type,
      subscriptionId: data?.id || '',
      frequencyPeriod,
      isBundle: isBundleOnly,
      bundleItems: bundleItems,
      variantInfo: variantInfo,
    }
    const includedItems = [
      ...bundleItems.mandatoryCount,
      ...bundleItems.optionalCount,
    ]
    const stockStatus = (
      data?.itemInfo?.[0]?.skus?.[0]?.inventory || ''
    ).toLowerCase()
    const isStockError =
      stockStatus === 'out of stock' || stockStatus === 'discontinued'
    const inventoryStatus =
      data?.itemInfo?.[0]?.skus?.[0]?.inventory?.toLowerCase()
    const isGift = data?.itemInfo?.[0]?.gifts?.length > 0
    const freeGiftsData = isGift ? data?.itemInfo?.[0]?.gifts : []
    const deduplicateGifts = gifts => {
      const giftMap = new Map()
      gifts.forEach(gift => {
        const skuId = gift?.skus?.[0]?.id
        if (skuId) {
          if (giftMap.has(skuId)) {
            const existing = giftMap.get(skuId)
            existing.quantity = (existing.quantity || 1) + (gift.quantity || 1)
          } else {
            giftMap.set(skuId, { ...gift, quantity: gift.quantity || 1 })
          }
        }
      })
      return Array.from(giftMap.values())
    }
    const deduplicatedFreeGifts =
      freeGiftsData.length > 0 ? deduplicateGifts(freeGiftsData) : []
    const popover = subscriptionContainer.renderFreeGiftSubscriptionPopover(
      deduplicatedFreeGifts
    )
    const disableActions =
      (inventoryStatus === 'out of stock' &&
        type != 'skukit' &&
        type != 'bundle' &&
        type != 'fixedbundle') ||
      ''
    const productStatus = data?.itemInfo?.[0]?.skus?.[0]?.status
    const isSubscription = data?.itemInfo?.[0]?.properties?.issubscription || ''
    // Show 'Out of stock' and 'In active' products in month tab of subscription dashboard
    const isProductStatusInactive =
      productStatus?.toLowerCase() === 'inactive' || isSubscription === false
    const isToDisableVariantDisplay =
      isBundleOnly || variantInfo.isNormalSkuWithMultiVariant
        ? isProductStatusInactive ||
          stockStatus === 'discontinued' ||
          isSkipped ||
          isStockError //Variant Edit Disabled for OUT OF STOCK products
        : false
    const customClass =
      isStockError ||
      disableActions ||
      isProductStatusInactive ||
      isSkipped ||
      isSkipmentSkips
        ? 'disabled'
        : ''
    let isDiscontinued = false
    if (isProductStatusInactive && type != 'skukit' && type != 'bundle') {
      if (
        data?.itemInfo?.[0]?.skus?.[0]?.skuProperties?.productStatus?.toLowerCase?.() ===
        'discontinued'
      ) {
        isDiscontinued = true
      }
    }
    const disableTabIndex = customClass === 'disabled' ? -1 : 0
    const isPbomSkukit = isPbomProduct(
      skuDetails,
      bundleItems?.bundle?.[0]?.type
    )

    const isToDisplayEditIconForVariants =
      enableSubscriptionMultiVariant() &&
      (isBundleOnly || variantInfo.isNormalSkuWithMultiVariant) &&
      (this.props.activeTab === 'nextOrder' ||
        this.props.activeTab === 'schedule')

    const itemId = data?.itemInfo?.[0]?.id || ''
    const frequencyData = {
      frequencyPeriod: frequencyPeriod,
      frequencyType: frequencyType,
      type: type,
    }

    const month = this.selectedSubscriptionFullDate?.getMonth() + 1 || 1
    return (
      <div
        className={`product-list__product-card ${
          isOneTime && 'one-time-product'
        }`}>
        <div className="d-flex w-100 product-card-section">
          <div className={`product-list-product-img ${customClass}`}>
            <LinkWithLocale
              tabIndex={disableTabIndex}
              to={{
                pathname: url || '',
              }}
              className={`prod-image-wrapper w-100`}
              data-testid="qa-subscription-next-order-product-image">
              <ImageComponent
                width="100px"
                height="100px"
                optimizeImage={true}
                src={productImage || imagePlaceholder}
                alt={productInfo.name}
                className={`mw-100 mh-100 prod-img`}
                data-testid="qa-user-sub-product-image"
              />
            </LinkWithLocale>
          </div>
          <div className={`d-flex w-100 product-card-deatils-section`}>
            <div className="subs-product-title-section d-flex">
              <LinkWithLocale
                tabIndex={disableTabIndex}
                to={{
                  pathname: url || '',
                }}>
                <div
                  data-testid="qa-subscription-name-next-order"
                  className={`subs-product-title ${customClass}`}>
                  {productInfo.name || ''}
                </div>
              </LinkWithLocale>
              <div className="d-flex">
                <Button
                  tabIndex={0}
                  className="details-delete-button"
                  variant="black"
                  data-testid={'qa-user-subs-product-delete'}
                  onClick={this.handleDeleteItem}>
                  <DeleteIcon aria-label={'product delete icon'} tabIndex={0} />
                </Button>
              </div>
            </div>
            <div>
              <div className="subs-product-sku-section d-flex">
                <div className={`subs-product-sku-left-section ${customClass}`}>
                  <div
                    data-testid="qa-subscription-skuId-next-order"
                    className="subs-product-sku">
                    <span className="">
                      {i18nTranslate('cart.itemId', 'SKU')}:
                    </span>
                    <span className="pl-1">{skuId}</span>
                  </div>
                  {isGift && (
                    <div className="subs-product-gift-card mt-2">
                      {i18nTranslate(
                        'subscriptionProdTile.giftIncluded',
                        'Free Gift Included'
                      )}{' '}
                      <OverlayTrigger
                        trigger="click"
                        placement="top"
                        rootClose={true}
                        overlay={popover}>
                        <InformationIcon
                          size="1.5rem"
                          className="subs-product-gift-info ml-2"
                        />
                      </OverlayTrigger>
                    </div>
                  )}
                  <div className="subscription-price d-flex w-100 subs-product-price">
                    <PriceSubscription
                      classStyles={`d-flex align-items-center flex-row justify-content-lg-end mb-2`}
                      transactionPrice={priceObj}
                      isStarterKit={data?.isStarterKit}
                      partNumber={data?.partNumber}
                    />
                  </div>
                  <div
                    className="sub-total-label d-flex"
                    data-testid="qa-subscription-sub-total-order">
                    <span className="pr-1 subs-product-total-label">
                      {i18nTranslate('subscriptionModal.subTotal', 'Subtotal')}
                    </span>
                    <span className=" subs-product-total-value">
                      {currencyFormat({
                        price: totalValue?.priceAfterDiscount || '',
                      })}
                    </span>
                  </div>
                  <PVCV
                    priceFacets={totalValue?.priceFacets}
                    oneTime={isOneTime}
                  />
                </div>
                <div className="subs-product-sku-right-section">
                  <div className="quantity-section d-flex align-items-end mt-2">
                    <div
                      className={`quantity-section-wrapper d-flex alignt-items-center flex-column ${customClass}`}>
                      <span>{i18nTranslate('quantity', 'Quantity')}</span>
                      <Quantity
                        onQuantityChange={this.handleQuantityChange}
                        defaultValue={
                          this.quantity || data?.itemInfo?.[0]?.quantity
                        }
                        isV2QuantityStyle={true}
                        disableTabIndex={disableTabIndex === 0 ? false : true}
                      />
                    </div>
                    {!isOneTime && (
                      <Button
                        className={`manage-skip-button p-0  d-flex align-items-center justify-content-center ${
                          isSkipped && 'skipped'
                        }  ${(!isSkipped || isSkipmentSkips) && customClass}`}
                        variant="outline-primary"
                        onClick={() => this.handleSkipItem(isSkipped)}
                        tabIndex={disableTabIndex}
                        data-testid="manage-skip-button">
                        {skipText}
                      </Button>
                    )}
                  </div>
                </div>
              </div>
              {isToDisplayEditIconForVariants && (
                <EditBundleMultiVariants
                  bundleData={details}
                  disableSelections={isToDisableVariantDisplay}
                  itemId={itemId}
                  frequencyData={frequencyData}
                  month={month}
                  selectedSubscriptionDate={this.selectedSubscriptionDate}
                  {...this.props}
                />
              )}

              <div
                className={`subscription-frequency-section d-flex ${customClass}`}>
                <div className="subscription-frequency-wrapper">
                  <FrequencyDropdownV2
                    disableTabIndex={disableTabIndex}
                    title={i18nTranslate('cart.frequency', 'Frequency')}
                    frequencyPeriod={this.frequencyData.frequencyPeriod}
                    frequencyType={this.frequencyData.frequencyType}
                    orderType={this.frequencyData?.type}
                    handleSubscriptionFrequency={
                      this.handleSubscriptionFrequency
                    }
                    isValidateReturn={true}
                    isToHideMonthlyFrequency={!isSubscriptionChannelAvailable}
                  />
                </div>
                <div className="subscription-calender-wrapper">
                  {this.renderDatePicker({ isOneTime, disableTabIndex })}
                </div>
                {!isOneTime &&
                  this.renderScanCardBtn(
                    productInfo,
                    isBundle,
                    isSkipped,
                    type,
                    disableTabIndex
                  )}
              </div>
            </div>
          </div>
        </div>
        {isBundle && !isPbomSkukit && (
          <BundleIncludedItemsCollapse
            customButtonClass={customClass}
            includedItems={includedItems}
            disableTabIndex={disableTabIndex}
          />
        )}
        {this.confirmDeleteModel && (
          <DeleteItemModal
            show={this.confirmDeleteModel}
            onHide={this.handleDeleteClose}
            handleCancelItem={this.handleCancelItem}
            itemDetails={details}
            selectedMonth={this.props.selectedMonth}
          />
        )}
        {this.confirmSkipModel && (
          <SkipItemModal
            show={this.confirmSkipModel}
            onHide={this.handleSkipClose}
            handlerSkipItem={this.handlerSkipItem}
            itemDetails={details}
            isSkipped={isSkipped}
            {...this.props}
          />
        )}
        {this.scanCardShow && (
          <CartScanCard
            isScanModalOpen={this.scanCardShow}
            toggleQuickView={this.toggleScanCardShow}
            productInfo={this.scanCardProductDetails}
            bundle={this.bundleScan}
            bundleScanCount={this.bundleScanCount}
            page="subscription"
            {...this.props}
          />
        )}
        {this.isInfoModalEnabled && (
          <CartScanInfo
            show={this.isInfoModalEnabled}
            onHide={this.toggleInfoModal}
          />
        )}
        <div className="d-flex flex-row justify-content-center prod-det-dropdown mt-2">
          {(isStockError || disableActions || isProductStatusInactive) && (
            <div className="w-100">
              <div
                className="d-flex d-md-block flex-column"
                data-testid="qa-subscription-inventory-error-text">
                <div
                  className="unavailable-item-text-with-border mb-2"
                  style={{
                    whiteSpace: this.props.isPvAssistantPage ? 'nowrap' : '',
                  }}>
                  {isStockError || disableActions
                    ? i18nTranslate('subscription.outOfStock', 'Out of Stock')
                    : isProductStatusInactive
                      ? isDiscontinued
                        ? i18nTranslate(
                            'Subscription.Discontinued',
                            'Discontinued'
                          )
                        : i18nTranslate(
                            'subscriptions.productStatusInactive',
                            'INACTIVE PRODUCT'
                          )
                      : i18nTranslate(
                          'subscription.unavailable',
                          'Unavailable'
                        )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default NextOrderProductDetails
export { NextOrderProductDetails }
